<template>
  <div class="bonus" :style="{ 'margin-left': ml + 'px' }">
    <div class="bonus_list" :class="{ emphasis : !isConfirm, large: isConfirm && orderPattern == 'confirm' || orderPattern == 'complete', 'justyfy_end': isConfirm }" :style="{ 'order': order[0] }">
      <div class="bonus_title rb c5a">口座振込額</div>
      <div class="bonus_price widthdraw_detail_text rm c5a" :style="{ width: isConfirm ? itemWidth + 'px' : '' }">{{ Number(withdrawPrice).toLocaleString() }}<span class="yen rb">円</span></div>
    </div>
    <div class="bonus_list" :class="{ 'justyfy_end': isConfirm }" :style="{ 'order': order[1] }">
      <div class="bonus_title rb c5a">振込事務手数料</div>
      <div class="bonus_price widthdraw_detail_text rm c5a" :style="{ width: isConfirm ? itemWidth + 'px' : '' }">{{ isBonus ? 0 : Number(withdrawFee).toLocaleString() }}<span class="yen rb">円</span></div>
    </div>
    <div class="bonus_list" :class="{ large: large && orderPattern == 'input', 'justyfy_end': isConfirm }" :style="{ 'order': order[2] }">
      <div class="bonus_title rb c5a">出金額合計</div>
      <div class="bonus_price widthdraw_detail_text rm c5a" :style="{ width: isConfirm ? itemWidth + 'px' : '' }">{{ amount.toLocaleString() }}<span class="yen rb">円</span></div>
    </div>
    <div class="bonus_list" :class="{ 'justyfy_end': isConfirm }" :style="{ 'order': order[3] }">
      <div class="bonus_title rb c5a">取引後ウォレット残高</div>
      <div class="bonus_price widthdraw_detail_text rm c5a" :style="{ width: isConfirm ? itemWidth + 'px' : '' }">{{ (cashAmount - amount).toLocaleString() }}<span class="yen rb">円</span></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

/*
orderPattern説明

input: 入力画面
-------------------
口座振込額
振込事務手数料
出金額合計
取引後ウォレット残高
-------------------


confirm: 確認画面
complete: 完了画面
-------------------
出金額合計
振込事務手数料
口座振込額
取引後ウォレット残高
-------------------
*/
export default {
  props: ['ml', 'isConfirm', 'large', 'orderPattern'],
  data() {
    return {
      order: [], // 順番が入る
      itemWidth: 0, // 確認、完了ページで右寄せ揃えるために使用
    }
  },
  computed: mapGetters(['totalAmount', 'cashAmount', 'withdrawFee', 'withdrawPrice', 'isBonus', 'amount']),
  created() {
    if(this.orderPattern == 'input') {
      this.order.push(...[0,1,2,3]);
    }
    if(this.orderPattern == 'confirm' || this.orderPattern == 'complete') {
      this.order.push(...[2,1,0,3]);
      let bonusPrice = document.getElementsByClassName('widthdraw_detail_text');
      console.log(bonusPrice);

      let width = 0;

      Array.prototype.forEach.call(bonusPrice, function(item) {
        console.log(item.clientWidth);
        if(width < item.clientWidth) {
          width = item.clientWidth;
        }
      });
      console.log(width);
      this.itemWidth = width;
    }
  },

}
</script>

<style lang="css" scoped>
.bonus {
  display: flex;
  flex-direction: column;
  margin-top: 29px;
  /* margin-left: 44px; */
  margin-right: 16px;
}
.bonus_list {
  display: flex;
  justify-content: space-between;
  line-height: 1;
  margin-top: 13px;
}

.bonus_list.emphasis {
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 24px;
}
.bonus_list.emphasis .bonus_title {
  font-size: 16px;
}

.bonus_list.emphasis .bonus_price {
  font-size: 32px;
  margin-top: 8px;
}
.bonus_list.large .bonus_title {
  font-size: 20px;
}
.bonus_list.large .bonus_price {
  font-size: 25px;
}
.bonus_list.large .bonus_price .yen {
  font-size: 16px;
}
.bonus_list.justyfy_end {
  align-items: center;
  justify-content: flex-end;
}
.bonus_list.justyfy_end .bonus_price {
  margin-left: 16px;
  justify-content: flex-end;
}

.bonus .bonus_list:last-child {
  border-top: 1px solid  #c9c9c9;
  padding-top: 10px;
}

.bonus_title {
  font-size: 14px;
}
.bonus_price {
  align-items: center;
  display: flex;
  font-size: 16px;
}

.bonus_price .yen {
  font-size: 12px;
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/wallet/WithdrawDetail.vue